import React, {useEffect, useRef, useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import useIsFocused from "../../../hooks/useIsFocused";

const RELOAD_INTERVAL = 1000 * 3; //3 seconds

const PoolIntensities = () => {
    const [recall, setRecall] = useState(true);
    const isFocused = useIsFocused();
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        city: "all",
        availableRate: "all",
        slotRate: "all",
        activity: "active",
        integrationType: "all"
    });
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const [loading, poolsAvailableRates] = useFetch({
        fetchFn: stores.poolShiftStore.getPoolsAvailableRates.bind(null, filters),
        waitForResponse: true,
        dependencies: [currentPage, recall, JSON.stringify(filters)]
    });

    useEffect(() => {
        if (isFocused) {
            let timeout = null;
            timeout = setTimeout(() => {
                setRecall(!recallRef.current);
            }, RELOAD_INTERVAL);
            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                    data={poolsAvailableRates?.data || []}
                />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={
                        poolsAvailableRates?.data
                            ?.map(p => ({
                                ...p,
                                availableRate: parseFloat(p?.availableRate).toFixed(0),
                                slotRate: parseFloat(p?.slotRate).toFixed(0)
                            })) ?? []
                    }
                    dataCount={0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};

export default PoolIntensities;
